export const pingAuth = async () => {
  try {
    console.log('pinging auth...')
    const response = await fetch('/user/pingauth', {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' }
    })
    if (response.ok) {
      return await response.json()
    } else {
      return null
    }
  } catch (error) {
    return null
  }
}
